import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import Datatable from "../../../../bmr/components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import { deleteMasterData, disableAddModal, enableAddModal, fetchMasterData, selectBmrAddMasterModal, selectMasterAllData, selectMasterDataLoading } from "../../../slices/customMaster";
import CommonForm from "./CommonForm";
import { useLocation } from "react-router-dom";
import { masterKeys } from "../../../constants/constant";

const TableManagement = () => {
    const dispatch = useDispatch()
    const { pathname } = useLocation();
    const slug = pathname?.split('/')?.filter(Boolean)?.pop();
    const isLoading = useSelector(selectMasterDataLoading)
    const addModal = useSelector(selectBmrAddMasterModal)
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const allMasterDataList = useSelector(selectMasterAllData);
    const title = masterKeys?.[slug] || '';
    const hideDescriptionSlugs = ['nationalities', 'ethnicity'];
    const showDescription = !hideDescriptionSlugs.includes(slug);

    const columns = [
        {
            id: 'name',
            name: 'Name',
            align: "center",

            selector: row => row.name,
            sortable: true
        },
        ...(showDescription ? [{
            id: 'description',
            name: 'Description',
            align: "center",

            selector: row => row.description,
            sortable: true
        }] : []),
        {
            id: 'type',
            name: 'Status',
            align: "center",
            selector: row => row.status ? <Typography className="text-[#369c50]">Active</Typography> : <Typography className="text-[#FF2023]">In-Active</Typography>,
            sortable: true
        },
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), setOpen(true) }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];

    const tableData = {
    items: allMasterDataList?.items || allMasterDataList?.data || [],
    total_count:
        allMasterDataList?.pageDetails?.no_of_records ||
        allMasterDataList?.no_of_records ||
        0,
    page: allMasterDataList?.pageDetails?.page || 1,
    per_page: allMasterDataList?.pageDetails?.per_page || 10,
};

const handleServerSideChange = async (params) => {
        try {
            const finalParam = {...params, slug: slug}
            await dispatch(fetchMasterData(finalParam));
        } catch (error) {
            console.error("Error fetching program code data:", error);
        }
    };


    const fetchData = async () => {
        await dispatch(disableAddModal())
        handleServerSideChange({ page: 1, per_page: 10, slug:slug });
    }

    useEffect(() => {
       fetchData()
    }, [slug]);
    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeMasterData = async () => {
        const { id } = rowData
        await dispatch(deleteMasterData({ id,slug }))
        setOpen(false)
    }

    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal open={addModal} onClose={handleCloseModal} title={rowData ? "Edit "+title : "Add "+title}>
                <CommonForm editData={rowData} slug={slug} />
            </BsModal>
            <Datatable
                columns={columns}
                data={tableData}
                title={title}
                searchPlaceholder="Search by Name"
                loading={isLoading}
                onServerSideChange={handleServerSideChange}
                remote={true}
                BtnComponent={<Button className="ml-2" onClick={() => (handleAddModal(), setRowData(null))}>Add New</Button>}
             />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeMasterData}
            />
        </div>
    </div>
}
export default TableManagement